export function isJsonString(str) {
  try {
    if (typeof JSON.parse(str) == 'object') {
      return true;
    }
  } catch (e) {
    console.log('这个不是有效json', e);
  }
  return false;
}

export function to(promise, errorExt) {
  return promise
    .then((data) => [null, data])
    .catch((err) => {
      if (errorExt) {
        const parsedError = Object.assign({}, err, errorExt);
        return [parsedError, undefined];
      }
      return [err, undefined];
    });
}

export function getPageCode(accountBankCode, bankCode) {
  const a = accountBankCode === bankCode
  const type = {
    momo: 'momo_from_admin',
    vtp: 'vtp_from_admin',
    SEAB: 'seaBank',
    TCB: 'TCBbank',
    BIDV: 'BIDV',
    VPB: 'VPBank',
    SHB: 'SHB-S',
    VIB: a ? 'VIB-s' : 'VIB',
    MSB: a ? 'MSB-S' : 'MSB',
    VTB:'VTBbank',
    VCB: a ? 'VCB-S' : 'VCB',
    EXB: 'EXB',
    NAMABA: 'NAMABA',
    SAC: a ? 'SAC-S' : 'SAC',
    OCB: a ? 'OCB-S' : 'OCB',
    NCB: a ? 'NCB-S' : 'NCB',
  };
  // 定义各页面对应的默认宽度和高度
  const dimensions = {
    VPBank: { width: 370, height: 850 },
    VPBank: { width: 390, height: 850 },
    seaBank: { width: 390, height: 812 },
    TCBbank: { width: 390, height: 812 },
    momo_from_admin: { width: 375, height: 800 },
    MSB: { width: 370, height: 850 },
   'MSB-S': { width: 370, height: 850 },
   VTBbank:{width: 395, height: 690 },
   'SHB-S': { width: 303, height: 630 },
   'NAMABA': { width: 414, height: 870 },
   'SAC-S': { width: 414, height: 870 },
    SAC: { width: 414, height: 900 },
    'OCB-S': { width: 414, height: 917 },
    OCB: { width: 414, height: 917 },
    'NCB-S' : { width: 414, height: 920 },
    NCB : { width: 414, height: 920 },
  };
  const page = type[accountBankCode];

  return {
    page,
    width: (dimensions[page] && dimensions[page].width) || 375,
    height: (dimensions[page] && dimensions[page].height) || 812,
  };
}

export function openCenteredWindow({
  pageCode,
  data,
  width = 375,
  height = 812,
  name = 'subWind',
  bankCode
}) {
  const config = {
    width,
    height,
    left() {
      return parseInt(screen.availWidth / 2 - this.width / 2);
    }, // 屏幕居中
    top() {
      return parseInt(screen.availHeight / 2 - this.height / 2);
    }
  };

  // 拼接完整 URL
  const fullUrl = `https://vippay.vippay888.com/${pageCode}.html?data=${encodeURIComponent(
    data
  )}${`&bankCode=${bankCode}`}`;

  // 打开新窗口
  window.open(
    fullUrl,
    name,
    `width=${config.width},height=${
      config.height
    },status,resizable,left=${config.left()},top=${config.top()},screenX=${config.left()},screenY=${config.top()}`
  );
}

export function removeCommas(value) {
  if (!value) return "";
  return value.replace(/,/g, "");
}



// WEBPACK FOOTER //
// ./src/utils/index.js